import React, { createContext, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../styles/expertDetails.css";
import LoadingIcon from "../images/Loading_icon.gif";
import SimilarProfileRow from "../components/SimilarProfiles/SimilarProfileRow";
import { UrlContext } from "../contexts/UrlContext";

export default function ExpertSimilarProfile() {
  useEffect(() => {
    document.title = "Expert Details";
  }, []);

  const { API_URL } = useContext(UrlContext);
  const id = useParams().id;
  const [experts, setExperts] = useState(null);
  useEffect(() => {
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value;
    const url = `${API_URL}similarProfile-load-more`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ expertID: id }),
    })
      .then((res) => res.json())
      .then((data) => {
        setExperts(data.experts);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <>
      <div className="search-con-table container-div">
        <div className="container-div">
          <h1 className="search-con-totalHeading">
            {experts?.length > 1
              ? `${experts?.length} similar profiles are found`
              : experts === 1
              ? `${experts.length} similar profile is found`
              : `. . . .`}
          </h1>
        </div>
        {experts ? (
          experts.map((expert, index) => (
            <SimilarProfileRow
              key={expert.ID}
              consultant={expert}
              proj_id={0}
            />
          ))
        ) : (
          <div style={{ textAlign: "center", marginTop: "50px" }}>
            <img
              src={LoadingIcon}
              alt="Loading..."
              style={{ height: "50px" }}
            />
            <h4 style={{ marginTop: "20px" }}>please wait</h4>
          </div>
        )}
      </div>
    </>
  );
}
